<template>
  <l-layout :layout="[ 'xs12']" bottom-space>
    <v-card>
      <!--Fixme 固定高度在vutify@1.4中已经不可用，会造成父级元素（v-card-title）塌陷-->
      <v-card-title class="py-0 my-0" style="height: 80px">
        <span v-if="data.obgrp.status==='-1'" class="title" style="color:red">【失效】</span>
        <span :class="data.name ? '':'grey--text'" class="title px-2">{{data.obgrp.name || '分组名称'}}</span>
        <slot name="time">
          <v-layout class="pl-2" wrap>
            <v-flex xs4 class="mr-2">
              <span class="grey--text caption mr-2">上次更新</span>
              <span
                :class="data.lastUpdateTime ? '':'grey--text'"
                class="pr-4">{{$L.time.stringify(data.obgrp.lastUpdateTime) || 'N/A'}}</span>
            </v-flex>
            <v-flex xs4 class="mr-2">
              <span class="grey--text caption mr-2">创建时间</span>
              <span
                :class="data.creationTime ? '':'grey--text'"
                class="pr-4">{{$L.time.stringify(data.obgrp.creationTime) || 'N/A'}}</span>
            </v-flex>
            <v-flex xs4>
              <span class="grey--text caption mr-2">过期时间</span>
              <span
                :class="data.expirationTime ? '':'grey--text'"
                class="pr-4">{{$L.time.stringify(data.obgrp.expirationTime) || 'N/A'}}</span>
            </v-flex>
          </v-layout>
        </slot>
        <v-spacer></v-spacer>
        <slot name="title-actions"></slot>
      </v-card-title>
      <v-tabs grow v-model="tab">
        <v-tab key="info">分组信息</v-tab>
        <v-tab key="vehicle">行人管理</v-tab>
        <v-tab key="rule">分组规则</v-tab>
        <v-tab key="specific" v-if="orderType==='admin'">特殊规则</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item key="info">
          <v-card-text>
            <v-container class="pb-0" fluid grid-list-md>
              <v-layout v-if="!data.editInfo" wrap>
                <v-flex :class="opt.layout" :key="i" v-for="(opt, i) in opts"  v-if="(i===0)||(orderType==='admin')||(orderType==='org')">
                  <info-cell v-bind="opt" v-model="data.obgrp[opt.key]"></info-cell>
                </v-flex>
              </v-layout>
              <v-layout v-else wrap>
                <v-flex :class="opt.layout" :key="i" v-for="(opt, i) in formDefine">
                  <l-input :config="opt" v-model="infoForm[opt.key]"></l-input>
                </v-flex>
              </v-layout>
              <v-layout justify-center column v-if="selfSignInfo.signUrl!==''&&data.obgrp.status==='1'">
                <h3 class="pl-4 ml-2">自助预约二维码</h3>
                <v-layout>
                  <v-flex xs2>
                    <img :src="selfSignInfo.signUrl" style="width:200px;height:200px">
                  </v-flex>
                  <v-flex xs6 class="ml-2 mt-5 pt-4">
                    <v-layout column>
                      <v-layout>
                        <v-flex xs6>
                          <v-text-field label="二维码开始登记时间" v-model="selfSignInfo.stTime" prepend-icon="$vuetify.icons.code"
                                        disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field label="二维码截止登记时间" v-model="selfSignInfo.edTime" prepend-icon="$vuetify.icons.code"
                                        disabled></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs6>
                          <v-text-field label="自助预约总数" v-model="selfSignInfo.total" prepend-icon="$vuetify.icons.code"
                                        disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field label="二维码短连接" v-model="selfSignInfo.qrcodeUrl" prepend-icon="$vuetify.icons.code"
                                        disabled></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="goEditInfo" color="primary" flat large v-if="!data.editInfo" :disabled="!data.obgrp.status==='1'" v-show="orderType==='admin'||orderType==='org'">编辑</v-btn>
            <v-btn @click="goReadonly" color="grey" flat large v-if="data.editInfo">取消</v-btn>
            <v-btn
              :loading="data.loading"
              @click="setGroupInfo"
              color="primary"
              flat
              large
              v-if="data.editInfo">提交
            </v-btn>
          </v-card-actions>
        </v-tab-item>
        <v-tab-item key="vehicle">
          <v-card>
            <l-data-table
              :get-data-func="getVehicles"
              :headers="vehicleHeaders"
              :filter-items="filter"
              flat
              selectable
              title-text="分组行人列表"
              @click:row="goDetails($event.item)"
              clickable
              ref="vehicleTable"
              v-model="selected"
            >
              <template slot="title-action">
                <l-option-menu
                  :options="moreActions"
                  @delete="deleteVehiclesConfirm"
                >
                  <v-btn icon slot="activator">
                    <v-icon>$vuetify.icons.more</v-icon>
                  </v-btn>
                </l-option-menu>
              </template>
              <template slot="row-action" slot-scope="{item}">
                <td @click.stop>
                  <v-btn @click="deleteVehicle(item)" icon :disabled="item.status==='-1'">
                    <v-icon >$vuetify.icons.delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </l-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item key="rule" style="min-height: 300px;">
          <v-layout class="py-2" wrap>
            <v-flex xs12>
              <v-layout column>
                <p class="pl-4 mt-3">有效规则</p>
                <l-pass-rule-list :pass-rules="data.rules" :passType="'person'">
                  <div @click.stop slot="action" slot-scope="{item, index}">
                    <l-option-menu
                      v-if="!(orderType==='org' || orderType === 'person')"
                      :options="options"
                      @delete="deletePassRule(item)"
                      @edit="openSetRuleDialog('edit',item, index)">
                      <v-btn icon slot="activator" small>
                        <v-icon small>$vuetify.icons.more</v-icon>
                      </v-btn>
                    </l-option-menu>
                  </div>
                </l-pass-rule-list>
              </v-layout>
            </v-flex>
            <v-flex v-if="orderType !== 'person'" class="px-2" xs12>
              <v-btn @click="openSetRuleDialog('new', null, data.rules.length)" color="primary" flat v-if="!(orderType==='org')">添加规则</v-btn>
            </v-flex>
            <v-flex xs12>
              <v-layout column>
                <v-divider></v-divider>
                <p class="pl-4 mt-3">失效规则</p>
                <l-pass-rule-list :pass-rules="data.failureRules">
                </l-pass-rule-list>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item key="specific" style="min-height: 300px;">
          <v-layout class="py-2" wrap>
            <v-flex xs12>
              <l-pass-rule-list :pass-rules="data.specifics" specific :passType="'person'">
                <div @click.stop slot="action" slot-scope="{item, index}">
                  <v-menu  left>
                    <v-btn slot="activator" icon small>
                      <v-icon  small>$vuetify.icons.more</v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile @click="openSetSpecificDialog('edit',item, index)" :disabled="!data.obgrp.status==='1'">
                        <v-list-tile-avatar>
                          <v-icon small>{{$vuetify.icons.edit}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-title class="pr-1">
                          编辑
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="deleteSpecific(item)" :disabled="!data.obgrp.status==='1'">
                        <v-list-tile-avatar>
                          <v-icon small>{{$vuetify.icons.delete}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-title class="pr-1">
                          删除
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </l-pass-rule-list>
            </v-flex>
            <v-flex class="px-2" xs12>
              <v-btn
                @click="openSetSpecificDialog('new', null, data.specifics.length)" :disabled="!data.obgrp.status==='1'"
                color="primary" flat>添加规则
              </v-btn>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
      <l-fixed-btn
        v-if="tab===1&&data.obgrp.status==='1'"
        @click="addVehicle"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-card>
    <v-dialog max-width="900px" persistent scrollable v-model="passRuleDialog.activate">
      <set-pass-rule-content
        :authority="authority"
        :pass-type="'person'"
        :params="{index: passRuleDialog.index, type: authority.name}"
        :rule="passRuleDialog.item"
        :status="passRuleDialog.status"
        @cancel="closeSetRuleDialog"
        @save="setPassRule($event.newItem)"
        ref="ruleContent"
        v-if="passRuleDialog.activate"
      ></set-pass-rule-content>
    </v-dialog>
    <v-dialog max-width="900px" persistent scrollable v-model="specificRuleDialog.activate">
      <set-pass-rule-content
        :authority="authority"
        :pass-type="'person'"
        :params="{index: specificRuleDialog.index, type: '特殊规则'}"
        :rule="specificRuleDialog.item"
        :status="specificRuleDialog.status"
        @cancel="closeSetSpecificDialog"
        @save="setSpecificRule($event.newItem)"
        ref="specificContent"
        v-if="specificRuleDialog.activate"
      >
        <template slot="append" slot-scope="{newItem, status}">
          <v-subheader class="mx-0">通行对象</v-subheader>
          <v-layout wrap class="mb-4">
            <v-flex xs12>
              <l-autocomplete
                :disabled="status === 'edit'"
                label="通行对象"
                :get-data="findVehicleInGroup"
                item-text="plate"
                prepend-icon="$vuetify.icons.car"
                v-model="newItem.vehicle"
              ></l-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-switch
                label="单独执行"
                v-model="newItem.isStandalone"
              ></v-switch>
            </v-flex>
          </v-layout>
        </template>
      </set-pass-rule-content>
    </v-dialog>
    <v-dialog v-model="deleteFlag" width="800">
      <v-card>
        <v-card-title>
          <p class="title">
            是否删除以下行人?
          </p>
        </v-card-title>
        <v-layout column>
          <l-data-table
          :items="selected"
          :headers="vehicleHeaders"
          hide-title></l-data-table>
          <v-layout justify-center>
            <v-btn class="primary" @click="deleteVehicles" :loading="loading">确定</v-btn>
            <v-btn class="error" @click="deleteFlag = false">取消</v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </v-dialog>
  </l-layout>
</template>

<script>
import LPassRuleList from '../../../components/LPassRuleList'
import InfoCell from '../../../components/infoCell'
import {ReservationGroup, ReservationAuthority, SpecificRule} from '../../../object'
import {RULE_ACTION_HEADERS, SPECIFIC_ACTION_HEADERS} from '../../../consts/pass'
import {passRule} from '@/mixins'
import SetPassRuleContent from '../../../components/SetPassRuleContent'
import {GROUP_VEHICLE_HEADER} from '@/consts/reservation'
import {time, F} from '../../../ladmin/utils'
import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
export default {
  name: 'PersonReservationGroupContent',
  components: {LDataTable, SetPassRuleContent, InfoCell, LPassRuleList},
  mixins: [passRule],
  props: {
    data: {
      type: Object,
      required: true
    },
    reservationStatus: {
      type: String,
      default: '1'
    },
    orderType:{
      type:String,
      default:"admin"
    }
  },
  data () {
    return {
      /* 过期标志 */
      overdateFlag: false,
      deleteFlag:false,
      loading:false,
      selfSignInfo: {
        signUrl: '',
        total: '',
        qrcodeUrl: '',
        stTime:'',
        edTime:''
      },
      specificRuleDialog: {
        activate: false,
        item: {},
        index: 0,
        status: 0
      },
      moreActions: [
        {
          event: 'delete',
          label: '批量删除',
          icon: '$vuetify.icons.deleteAll'
        },
      ],
      selected:[],
      userSelect: [],
      infoForm: {},
      tab: 0,
      vehicleHeaders: [
        {text: '通行对象', value: 'plate', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '访客手机', value: 'phone', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '访客姓名', value: 'name', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '开始时间', value: 'startDatetime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
        {text: '结束时间', value: 'endDatetime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
        {text: '是否有效', value: 'status', align: 'left', placeholder: 'N/A', f: (v) => (v === '1' ? '有效' : '失效')},
        {text: '', value: '', sortable: false}],
      ruleHeaders: RULE_ACTION_HEADERS,
      specificHeaders: SPECIFIC_ACTION_HEADERS,
      rules: [],
      specifics: [],
      options: [
        {
          event: 'edit',
          icon: '$vuetify.icons.edit',
          label: '编辑'
        },
        {
          event: 'delete',
          icon: '$vuetify.icons.delete',
          label: '删除'
        }
      ],
      opts: [
        {
          key: 'name',
          label: '分组名称',
          layout: ['xs12'],
          icon: '$vuetify.icons.group',
        },
        {
          key: 'description',
          label: '分组描述',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.description'
        },
      ],
      formDefine: [
        {
          type: 'input',
          key: 'name',
          label: '分组名称',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.group'
        },
        {
          type: 'input',
          key: 'description',
          label: '分组描述',
          layout: ['xs12'],
          prependIcon: '$vuetify.icons.description'
        },
      ],
      filter: [
        {
          prependIcon: '$vuetify.icons.edit',
          key: 'status',
          value: this.data.obgrp.rhdata,
          label: '是否有效',
          type: 'select',
          layout: ['xs12', 'sm4'],
          items: [
            {
              value: '',
              text: '全部'
            },
            {
              value: '{"r_h_status":"1"}',
              text: '有效'
            },
            {
              value: '{"r_h_status":"-1"}',
              text: '失效'
            }],
        },
        {
          label: '开始时间',
          layout: 'xs12, sm4',
          type: 'duration',
          key: 'startDatetime',
          value: {},
          range: true,
          f: v => {
            if (!v.startDatetime && !v.endDatetime) {
              return null
            }
            else {
              let s = time.toTimeStamp(v.startDatetime) || 0
              let e = time.toTimeStamp(v.endDatetime) || 9999999999999
              return [s, e]
            }
          }
        },
        {
          label: '截止时间',
          layout: 'xs12, sm4',
          type: 'duration',
          key: 'endDatetime',
          value: {},
          range: true,
          f: v => {
            if (!v.startDatetime && !v.endDatetime) {
              return null
            }
            else {
              let s = time.toTimeStamp(v.startDatetime) || 0
              let e = time.toTimeStamp(v.endDatetime) || 9999999999999
              return [s, e]
            }
          }
        },
        {
          prependIcon: '$vuetify.icons.phone',
          key: 'visitorPhone',
          value: '',
          label: '联系电话',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ]
    }
  },
  computed: {
    authority () {
      let auth = this.$store.state.personReservation.adminAuth
      auth.editPrompt = false
      return auth
    }
  },
  methods: {
    goEditInfo () {
      this.infoForm = new ReservationGroup(this.data.obgrp)
      this.infoForm.ledPromptIn = this.data.obgrp.osdMsgIn
      this.infoForm.ledPromptOut = this.data.obgrp.osdMsgOut
      this.infoForm.audioPromptIn = this.data.obgrp.vcbMsgIn
      this.infoForm.audioPromptOut = this.data.obgrp.vcbMsgOut
      this.data.editInfo = true
    },
    goReadonly () {
      this.data.editInfo = false
    },
    async setGroupInfo () {
      try {
        this.$set(this.data.obgrp, 'loading', true)
        if (this.infoForm.expirationTime.length !== 19) {
          this.infoForm.expirationTime += ':00'
        }
        let g = await this.$store.dispatch('personReservation/setReservationGroup', this.infoForm)
        this.$emit('refresh')
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.$set(this.data.obgrp, 'loading', false)
      }
    },
    openSetSpecificDialog (status, item, index) {
      this.specificRuleDialog = {
        activate: true,
        status: status,
        item: item || new SpecificRule(),
        index: index
      }
    },
    closeSetSpecificDialog () {
      this.specificRuleDialog = {
        activate: false,
        status: 'new',
        item: {},
        index: 0
      }
    },
    async setSpecificRule (rule) {
      try {
        // console.log(rule)
        await this.$store.dispatch('personReservation/setSpecificRule', rule)
        this.closeSetSpecificDialog()
        this.getSpecifics()
        this.$L.alert('success', `操作成功`)
      }
      catch (e) {
        console.error(e)
        this.$L.alert('error', e.message)
        this.$refs.specificContent.stopLoading()
      }
    },
    async setPassRule (rule) {
      if (!rule.groupId) {
        rule.groupId = this.data.obgrp.id
      }
      try {
        await this.$store.dispatch('personReservation/setRule', rule)
        this.closeSetRuleDialog()
        this.getRules()
        this.$L.alert('success', `操作成功`)
        this.$emit('refresh')
      }
      catch (e) {
        this.$L.alert('error', e.message)
        this.$refs.ruleContent.stopLoading()
      }
    },
    async findVehicleInGroup (searchValue) {
      try {
        let {items} = await this.getVehicles({
          pagination: {},
          search: searchValue
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async deletePassRule (rule) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除',
        text: '确认删除该规则？'
      })
      if (res) {
        try {
          await this.$store.dispatch('personReservation/deleteRules', [rule])
          this.getRules()
          this.$L.alert('success', '删除成功')
          this.$emit('refresh')
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteSpecific (rule) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除',
        text: '确认删除该规则？'
      })
      if (res) {
        try {
          await this.$store.dispatch('personReservation/deleteRules', [rule])
          this.getSpecifics()
          this.$L.alert('success', '删除成功')
          this.$emit('refresh')
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async getVehicles ({pagination, sortStack, filterItems = [], search}) {
      let res = await this.$store.dispatch('personReservation/getVehicles', {group: this.data.obgrp, search: {key: 'plate', value: search}, sortStack: sortStack, pagination: pagination, filter: filterItems})
      return res
    },
    async getRules () {
      try {
        // Fixme 需要从页面上支持分页
        let {items} = await this.$store.dispatch('personReservation/getRules', {
          groupId: this.data.obgrp.id,
          pagination: {page: 1, rowsPerPage: 100},
        })
        //console.log(items)
        this.data.rules = []
        this.data.failureRules = []
        for (let i = 0; i < items.length; i++) {
          let rule = items[i]
          if (rule.status === '-1') {
            this.data.failureRules.push(rule)
          }
          else {
            this.data.rules.push(rule)
          }
        }
      }
      catch (e) {
        console.error(e)
        this.$L.alert('error', e.message)
      }
    },
    async getSpecifics () {
      try {
        let {items} = await this.$store.dispatch('personReservation/getAllSpecifics', {
          group: this.data.obgrp,
          pagination: {page: 1, rowsPerPage: 100}
        })
        this.data.specifics = items
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    },
    addVehicle () {
      console.log(this.data)
      this.$router.push({
        name: 'PersonNewGroupReservation',
        query: {
          status: 'addVehicle',
          id: this.data.obgrp.id
        }
      })
    },
    goDetails (item) {
      console.log(item)
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'PersonStatisticDetails',
          params: {
            plate: item.plate
          }
        })
      }
    },
    isOverDate (v) {
      let date = new Date()
      if (v < date.getTime()) {
        this.overdateFlag = true
      }
      else {
        this.overdateFlag = false
      }
    },
    async deleteVehicle (item) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该行人，手机号：' + item.plate})
      if (res) {
        try {
          let ids = []
          ids.push(item.id)
          let res = await this.$store.dispatch('personReservation/deleteVehicles', ids)
          if (res.data.status === 1) {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.vehicleTable.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    dealExtend () {
      if (this.data.obgrp.extend !== null) {
        let extend = JSON.parse(this.data.obgrp.extend)
        console.log(extend)
        if (extend.qrcodePath !== undefined) {
          this.selfSignInfo.signUrl = '/qrcode' + extend.qrcodePath
          this.selfSignInfo.total = extend.total
          this.selfSignInfo.qrcodeUrl = extend.qrcodeUrl
          this.selfSignInfo.stTime = time.stringify(extend.selfCheckStTime)
          this.selfSignInfo.edTime = time.stringify(extend.selfCheckEdTime)
        }
      }
    },
    deleteVehiclesConfirm(){
      this.deleteFlag = true
    },
    async deleteVehicles(){
      this.loading = true
      try {
        let ids = []
        for(let i=0;i<this.selected.length;i++){
          ids.push(this.selected[i].id)
        }
        let res = await this.$store.dispatch('personReservation/deleteVehicles', ids)
        if (res.data.status === 1) {
          this.$L.alert('success', {message: '删除成功'})
          this.$refs.vehicleTable.refresh()
        }
        else {
          this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
        }
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }finally {
        this.deleteFlag = false
        this.loading = false
      }
    }
  },
  activated () {
    if (this.$L.tab.currentTab && !this.$L.tab.currentTab.desc) {
      this.$L.tab.set(this.$L.tab.current, {desc: this.data.obgrp.name})
    }
    console.log('activated', this.data)
  },
  created () {
    console.log(this.orderType)
    if (this.data.obgrp.rhdata !== undefined) {
      let status = JSON.parse(this.data.obgrp.rhdata).r_h_status
      this.data.obgrp.status = status + ''
    }
    else {
      this.data.obgrp.status = '-1'
    }
    if (this.$L.tab.currentTab && !this.$L.tab.currentTab.desc) {
      this.$L.tab.set(this.$L.tab.current, {desc: this.data.obgrp.name})
    }
    this.dealExtend()
    this.getRules()
    this.getSpecifics()
    this.isOverDate(time.toTimeStamp(this.data.obgrp.expirationTime))
  }
}
</script>

<style scoped>

</style>
